import React from "react";
import {
  EditButton,
  ListButton,
  RefreshButton as RefreshButtonAdmin
} from "admin-on-rest";
import CreateButton from '../CreateButton';
import RefreshButton from "../RefreshButton";
import BulkDeleteButton from "../BulkDeleteButton";
import {CardActions} from "material-ui/Card";
import IconMenu from "material-ui/IconMenu";
import MenuItem from "material-ui/MenuItem";
import IconButton from "material-ui/IconButton";
import MoreHorizIcon from "material-ui/svg-icons/navigation/more-horiz";
import actionBarStyle from "./style";
import { BMTheme } from "../../../BMTheme";

class ActionBar extends React.Component {
  render() {
    const {
      resource,
      filters,
      displayedFilters,
      filterValues,
      basePath,
      editButton,
      showFilter,
      createButton,
      deleteButton,
      data,
      actionBarForShowView,
      withActionMenu,
      record
    } = this.props;

    return (
      <div>
        {actionBarForShowView ? (
          <CardActions style={actionBarStyle.cardActionStyle}>
            {editButton && editButton.state === "unsent" && (
              <EditButton basePath={basePath} record={data} />
            )}
            <ListButton basePath={basePath} />
            <RefreshButtonAdmin />
          </CardActions>
        ) : (
          <CardActions style={actionBarStyle.cardActionStyle}>
            {filters &&
              React.cloneElement(filters, {
                resource,
                showFilter,
                displayedFilters,
                filterValues,
                context: "button"
              })}
            {createButton !== false && <CreateButton basePath={basePath} />}

            {withActionMenu !== false && (
              <IconMenu
                iconButtonElement={
                  <IconButton>
                    <MoreHorizIcon color={BMTheme.icons.color}/>
                  </IconButton>
                }
                anchorOrigin={{horizontal: "left", vertical: "top"}}
                targetOrigin={{horizontal: "left", vertical: "top"}}
                useLayerForClickAway={true}
                iconStyle={actionBarStyle.iconStyle}
              >
                <MenuItem
                  children={
                    <RefreshButton basePath={basePath} record={record} />
                  }
                />

                {deleteButton !== false && (
                  <MenuItem
                    children={
                      <BulkDeleteButton basePath={basePath} record={record} />
                    }
                  />
                )}
              </IconMenu>
            )}
          </CardActions>
        )}
      </div>
    );
  }
}

export default ActionBar;



// WEBPACK FOOTER //
// ./src/components/CRM/ActionBar/index.js